module.exports = __webpack_public_path__ + "img/twit.f69bedd6.svg";